import styled from 'styled-components';
import { Button, BUTTON_SIZES, BUTTON_VARIANTS } from 'ui/button';
import { spacing } from 'ui/theme';

import { ImageAttrs } from '../../constants';
import { usePanelContext } from '../../contexts/Panel';
import { useTranslations } from '../../hooks/useTranslations';

const Footer = styled.div`
  display: flex;
  justify-content: flex-end;
  flex: 1 1 auto;
  column-gap: ${spacing.half};
`;

export const testIds = {
  footerBtnCancel: 'mi-panel-detail-footer_btn-cancel',
  footerBtnInsert: 'mi-panel-detail-footer_btn-insert',
  footerBtnSelect: 'mi-panel-detail-footer_btn-select',
};

export const PanelFooter = () => {
  const { t } = useTranslations();
  const {
    imageAttrState,
    imgMetadata,
    linkAttrState,
    nonCustomizableAttrs,
    onCancel,
    onClose,
    onInsert,
    onSelect,
    selectedEditorImageNode,
  } = usePanelContext();

  // inserting (or replacing) an image into the editor
  const handleInsert = () => {
    if (onInsert) {
      onInsert({ ...imageAttrState, ...nonCustomizableAttrs }, linkAttrState);
    }
    onClose();
  };

  // inserting (or replacing) the image url into a form field
  const handleSelect = () => {
    if (onSelect) {
      onSelect(imageAttrState[ImageAttrs.SOURCE], imgMetadata);
      onClose();
    }
  };

  return (
    <Footer>
      <Button
        onClick={onCancel}
        size={BUTTON_SIZES.MEDIUM}
        variant={BUTTON_VARIANTS.GHOST}
        data-test={testIds.footerBtnCancel}
      >
        <span>{t('button.cancel')}</span>
      </Button>
      {!!onSelect && (
        <Button
          data-test={testIds.footerBtnSelect}
          onClick={handleSelect}
          size={BUTTON_SIZES.MEDIUM}
          variant={BUTTON_VARIANTS.PRIMARY}
        >
          <span>{t('button.select')}</span>
        </Button>
      )}
      {!!onInsert && (
        <Button
          data-test={testIds.footerBtnInsert}
          onClick={handleInsert}
          size={BUTTON_SIZES.MEDIUM}
          variant={BUTTON_VARIANTS.PRIMARY}
        >
          <span>{t(!!onInsert && !selectedEditorImageNode ? 'button.insert' : 'button.save')}</span>
        </Button>
      )}
    </Footer>
  );
};
